/*!
 * Created by netlogix GmbH & Co. KG.
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { Action } from '@ngrx/store';
import { Reminder } from '@shared/models';

export const INIT = '[Reminders] Init';
export const LOAD_MY_REMINDERS = '[Reminders] Load mine';
export const LOAD_MY_REMINDERS_SUCCESS = '[Reminders] Load mine success';
export const LOAD_MY_REMINDERS_FAILURE = '[Reminders] Load mine failure';
export const SHOW_REMINDER_OVERLAY = '[Reminders] Show overlay';
export const SET_REMINDER_INACTIVE = '[Reminders] Set inactive';
export const SET_REMINDER_INACTIVE_SUCCESS = '[Reminders] Set inactive success';
export const SET_REMINDER_INACTIVE_FAILURE = '[Reminders] Set inactive failure';
export const SET_REMINDER_TIMERS = '[Reminders] Set timer ids';
export const SUSPEND_REMINDER = '[Reminders] Suspend reminder';
export const RESUME_REMINDER = '[Reminders] Resume reminder';

export class Init implements Action {
  readonly  type = INIT;
  constructor(public myReminders: Reminder[]) { }
}

export class LoadMyReminders implements Action {
  readonly type = LOAD_MY_REMINDERS;
}

export class LoadMyRemindersSuccess implements Action {
  readonly type = LOAD_MY_REMINDERS_SUCCESS;
  constructor(public myReminders: Reminder[]) { }
}

export class LoadMyRemindersFailure implements Action {
  readonly type = LOAD_MY_REMINDERS_FAILURE;
}

export class ShowReminderOverlay implements Action {
  readonly type = SHOW_REMINDER_OVERLAY;
  constructor(public reminder: Reminder) { }
}

export class SetReminderInactive implements Action {
  readonly type = SET_REMINDER_INACTIVE;
  constructor(public reminderId: string) { }
}

export class SetReminderInactiveSuccess implements Action {
  readonly type = SET_REMINDER_INACTIVE_SUCCESS;
}

export class SetReminderInactiveFailure implements Action {
  readonly type = SET_REMINDER_INACTIVE_FAILURE;
}

export class SetReminderTimers implements Action {
  readonly type = SET_REMINDER_TIMERS;
  constructor(public timerIds: number[]) { }
}

export class SuspendReminder implements Action {
  readonly type = SUSPEND_REMINDER;
  constructor(public reminderId: string) { }
}

export class ResumeReminder implements Action {
  readonly type = RESUME_REMINDER;
  constructor(public reminderId: string) { }
}

export type ReminderActions = Init | LoadMyReminders | LoadMyRemindersSuccess | LoadMyRemindersFailure | SetReminderInactive |
  ShowReminderOverlay | SetReminderInactiveSuccess | SetReminderInactiveFailure | SetReminderTimers | SuspendReminder |
  ResumeReminder;
